<template>
  <div
    ref="kt_modal_faturamento_editar_pedido_compra"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_pedido_compra"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Pedido de Compra</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Nº Pedido de Compra</label>
              <input
                type="text"
                id="txtxPed"
                :class="[
                  'form-control mb-2',
                  errosValidacao['xPed'] ? 'is-invalid' : '',
                ]"
                v-model="this.refPed.xPed"
                maxlength="15"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["xPed"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Item do Pedido de Compra</label>
              <input
                type="text"
                id="txtnItemPed"
                :class="[
                  'form-control mb-2',
                  errosValidacao['nItemPed'] ? 'is-invalid' : '',
                ]"
                v-model="this.refPed.nItemPed"
                maxlength="6"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["nItemPed"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const refPedInicializado = {
  xPed: "",
  nItemPed: 0,
};

export default {
  components: {},
  emits: [
    "exibirModalEditarPedidoCompra",
    "adicionarPedidoCompra",
    "editarPedidoCompra",
  ],
  props: {
    index: { type: Number, required: true, default: -1 },
    refPedFaturamento: { type: Object, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        if (this.index === -1) {
          this.$emit("adicionarPedidoCompra", this.refPed);
        } else {
          this.$emit("editarPedidoCompra", this.refPed, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_pedido_compra);
        this.$emit("exibirModalEditarPedidoCompra", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    validar() {
      let result = true;

      if (!this.refPed.xPed) {
        this.errosValidacao.xPed = "Informe o número do pedido de compra";
        result = false;
      } else if (this.refPed.xPed.trim().length <= 0) {
        this.errosValidacao.xPed = "Informe o número do pedido de compra";
        result = false;
      }

      if (!this.refPed.nItemPed) {
        this.errosValidacao.nItemPed = "Informe o item do pedido de compra";
        result = false;
      } else if (this.refPed.nItemPed.trim().length <= 0) {
        this.errosValidacao.nItemPed = "Informe o item do pedido de compra";
        result = false;
      } else if (!this.$utils.isNumeric(this.refPed.nItemPed.trim())) {
        this.errosValidacao.nItemPed = "O campo aceita somente números";
        result = false;
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_pedido_compra);
      this.$emit("exibirModalEditarPedidoCompra", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.refPed = JSON.parse(JSON.stringify(this.refPedFaturamento));
    } else {
      this.refPed = JSON.parse(JSON.stringify(refPedInicializado));
    }
    this.errosValidacao = {};
    this.$utils.requestFocus("txtxPed");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      refPed: JSON.parse(JSON.stringify(refPedInicializado)),
    };
  },
};
</script>

<style></style>
